<template>
    <v-form ref="form" lazy-validation>
        <v-card>
            <v-card-title class="display-1 font-weight-light" primary-title>
                Ajouter des tags
            </v-card-title>

            <v-card-text>
                <div>
                    Les tags séléctionnés seront ajoutés à tous les documents du dossier.
                    <br>
                    Cela ne prend pas en compte les documents des les sous-dossiers.
                </div>

                <TagsCombobox ref="tagsSelect"/>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="green lighten-2 white--text" :disabled="loading" @click="validate">
                    Enregistrer
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
    import TagsCombobox from "./TagsCombobox";
    import {DIRECTORY_ADD_TAGS} from "../../store/actions.type";

    export default {
        name: "DirectoryTagForm",
        components: {TagsCombobox},
        props: {
            directory: {
                type: Object,
                default: null
            }
        },
        data: () => ({
            loading: false
        }),
        computed: {
            selectedTags: function () {
                return this.$refs.tagsSelect.choices;
            },
        },
        methods: {
            /**
             * Soumission du formulaire
             */
            validate() {
                if (this.directory && this.$refs.form.validate()) {
                    this.loading = true;

                    this.$store.dispatch(DIRECTORY_ADD_TAGS, {
                        directorySlug: this.directory.slug,
                        tags: this.selectedTags
                    }).then(() => {
                        this.$emit('tag-form-close');
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            }
        }
    };
</script>

<style scoped lang="scss">
</style>
